var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-container" },
    [
      _c("van-nav-bar", {
        attrs: { title: _vm.$route.meta.title },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function() {
              return [
                _c("van-icon", {
                  attrs: { name: "arrow-left", color: "#46474B", size: "20px" },
                  on: { click: _vm.back }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("div", { staticClass: "pay-loading text-align-center" }, [
        _c("img", {
          attrs: { src: require("@/assets/pay-state/pay-loading.png"), alt: "" }
        }),
        _c("p", [_vm._v("支付查询中(" + _vm._s(_vm.second) + "s)...")])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }